import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Weight } from "lucide-react";
import { Control } from "react-hook-form";
import { FormData } from "./schema";
import { FormattedNumberInput } from "@/components/ui/formattedNumberInput";

interface WeightCardProps {
  control: Control<FormData>;
}

export function WeightCard({ control }: WeightCardProps) {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="flex items-center gap-2 text-lg">
          <Weight className="h-4 w-4" />
          Freight Weight
        </CardTitle>
        <CardDescription>Total weight of the freight in pounds</CardDescription>
      </CardHeader>
      <CardContent>
        <FormField
          control={control}
          name="weight"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Weight (lbs) *</FormLabel>
              <FormControl>
                <FormattedNumberInput
                  value={field.value || 0}
                  onChange={(value) => {
                    field.onChange(value);
                  }}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      </CardContent>
    </Card>
  );
}
